import { notification } from 'antd';
import axios from 'axios';

import moment from 'moment';

import { all, takeEvery, put, call } from 'redux-saga/effects';

import { firebaseFirestore, firebaseAuth, baseUrl } from 'services/firebase';

import { intl } from 'utils/intl';

import downloadCSV from 'utils/downloadCSV';

import {
  fetchCampaignGiftReportsSuccess,
  setCampaignReportsState,
  fetchGiftWinnersSuccess,
} from './actions';

import CampaignActionTypes from './types';

export function* fetchCampaignGiftsAsync({ payload }) {
  yield put(setCampaignReportsState({ isFetchingCampaignGifts: true }));

  try {
    const campaignGiftsRef = yield firebaseFirestore.collection(`campaigns/${payload}/gifts`);
    const snapshot = yield campaignGiftsRef.get();

    const campaignGiftDocs = snapshot.docs;

    const campaignGifts = (campaignGiftDocs || []).map(doc => {
      const { gift, totalWon } = doc.data();
      return {
        ...gift,
        totalWon,
      };
    });

    yield put(fetchCampaignGiftReportsSuccess(campaignGifts));
    yield put(setCampaignReportsState({ isFetchingCampaignGifts: false }));
  } catch (error) {
    yield put(setCampaignReportsState({ isFetchingCampaignGifts: false }));
    notification.error({
      message: intl.formatMessage({ id: 'campaign.notification.error.title' }),
      description: intl.formatMessage({ id: 'reports.campaign.gifts.notification.fetch.error' }),
    });
  }
}

export function* fetchGiftWinnersAsync({ payload }) {
  const { giftId, campaignId } = payload;

  yield put(setCampaignReportsState({ isFetchingGiftWinners: true }));

  try {
    const winnersRef = yield firebaseFirestore.collection(
      `campaigns/${campaignId}/gifts/${giftId}/winners`,
    );
    const snapshot = yield winnersRef.get();

    const winnersDocs = snapshot.docs;

    const winners = (winnersDocs || []).map(doc => {
      return doc.data().userDetails;
    });

    yield put(fetchGiftWinnersSuccess(winners));
    yield put(setCampaignReportsState({ isFetchingGiftWinners: false }));
  } catch (error) {
    yield put(setCampaignReportsState({ isFetchingGiftWinners: false }));
    notification.error({
      message: intl.formatMessage({ id: 'campaign.notification.error.title' }),
      description: intl.formatMessage({
        id: 'reports.campaign.gifts.winners.notification.fetch.error',
      }),
    });
  }
}

export function* exportCouponsAsync({ payload }) {
  const { from, to, campaignId } = payload;

  try {
    const token = yield firebaseAuth.currentUser.getIdToken();
    const url = `${baseUrl}/generateCouponReportForDates?campaignId=${campaignId}&dateFrom=${from}&dateTo=${to}`;

    const result = yield axios.get(url, { headers: { Authorization: `Bearer ${token}` } });

    if (result && result.data) {
      const coupons = (result.data.data || []).map(coupon => {
        const { scannedDate } = coupon;
        return {
          ...coupon,
          // eslint-disable-next-line no-underscore-dangle
          scannedDate: moment(new Date(scannedDate._seconds * 1000)).format('DD.MM.YYYY h:mm'),
        };
      });

      yield call(downloadCSV, {
        filename: `reports-${moment(from).format('DD-MM-YYYY')}-to-${moment(to).format(
          'DD-MM-YYYY',
        )}.csv`,
        data: coupons,
        columns: ['id', 'scannedDate', 'totalCouponScanRequests'],
      });
    }

    yield put(setCampaignReportsState({ isExportingCoupons: false }));
  } catch (error) {
    yield put(setCampaignReportsState({ isExportingCoupons: false }));
    notification.error({
      message: intl.formatMessage({ id: 'campaign.notification.error.title' }),
      description: intl.formatMessage({ id: 'reports.campaign.coupons.notification.export.error' }),
    });
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(CampaignActionTypes.FETCH_CAMPAIGN_GIFT_REPORTS_START, fetchCampaignGiftsAsync),
    takeEvery(CampaignActionTypes.FETCH_GIFT_WINNERS_START, fetchGiftWinnersAsync),
    takeEvery(CampaignActionTypes.EXPORT_COUPONS_START, exportCouponsAsync),
  ]);
}
